import { z } from 'zod';
import { requiredString } from '../helpers';
export const Hubspot_Get_Contact_1_ConfigValidator = z.object({
    hubspotConnection: requiredString('HubSpot Connection is required'),
    email: requiredString('Email is required'),
    additionalProperties: z.string().optional(),
    expectedOutput: z
        .string()
        .optional()
        .refine((val) => {
        if (!val || val === '')
            return true;
        try {
            JSON.parse(val);
            return true;
        }
        catch {
            return false;
        }
    }, { message: 'Expected output must be valid JSON' })
});
//# sourceMappingURL=hubspot-get-contact-1.js.map